import { useContext } from 'react';

// components
import { DescriptionDefault } from './description-default';
import { DescriptionActive } from './description-active';

// utils
import { InteractiveDescriptionContext } from '../context';

export function DescriptionDesktop() {
  const { contentWhenClicked } = useContext(InteractiveDescriptionContext);

  if (contentWhenClicked) {
    return <DescriptionActive />;
  }

  return <DescriptionDefault />;
}
